import React from 'react'
import PropTypes from 'prop-types'

import { ContextHeadline } from '@aok/text-elements'
import { PrimaryButton } from '@aok/ui-elements'
import { getHeadlineText } from '../../../utils/TextUtils'

import MacroContainer from '../../_layout/Macro/MacroContainer'
import defaultProps from '../../../utils/propTypes/defaultProps'
import { ComponentVariant } from '../../../utils/defaultTypes'

const M006M = ({ headline, text, link }) => {
  const headlineClasses = 'text-ffffff'

  return (
    <MacroContainer dataTrackingName="M006M">
      <div
        className="
            bg-005e3f py-48 px-16
            600:px-24
            840:grid 840:grid-cols-8 840:gap-24
            1000:gap-32
          "
      >
        <div
          className="
              840:col-start-2 840:col-end-8
            "
        >
          <ContextHeadline
            text={getHeadlineText(headline, headlineClasses)}
            className="
                text-24 leading-32 text-50eb5d text-center
                font-semibold font-buenos-aires
              "
          />
          <p
            className="
                text-16 leading-24 text-ffffff text-center
                mt-24
              "
          >
            {text}
          </p>

          <div className="flex flex-col justify-center items-center mt-40">
            <PrimaryButton url={link.url} target={link.target} backgroundVariant="green">
              {link.title}
            </PrimaryButton>
          </div>
        </div>
      </div>
    </MacroContainer>
  )
}

M006M.propTypes = {
  headline: PropTypes.shape({
    text: PropTypes.string,
    placeholder: PropTypes.shape({
      text: PropTypes.string,
    }),
  }),
  text: PropTypes.string,
  link: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
    target: PropTypes.oneOf(['_blank', '_self']),
  }),
  settings: PropTypes.shape({
    variant: PropTypes.oneOf([ComponentVariant.MEDIUM, ComponentVariant.LARGE]),
  }),
}

M006M.defaultProps = {
  headline: {
    text: defaultProps.HEADLINE,
  },
  text: defaultProps.TEXT,
  link: {
    title: defaultProps.TITLE,
    url: defaultProps.URL,
    target: '_self',
  },
  settings: {
    variant: ComponentVariant.MEDIUM,
  },
}

export default M006M
